"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors = {
    "purple100": "#fbf0ff",
    "purple200": "#edc8ff",
    "purple300": "#de99ff",
    "purple400": "#c158f8",
    "purple500": "#990ae3",
    "purple600": "#7800b4",
    "purple700": "#5e0092",
    "purple800": "#30004b",
    "purple850": "#29003e",
    "purple900": "#1f002e",
    "beige50": "#f8eee8",
    "beige100": "#ecded4",
    "beige200": "#d4c4ba",
    "beige300": "#b4a49c",
    "beige400": "#988a84",
    "beige500": "#827672",
    "beige600": "#5c524e",
    "beige700": "#403a36",
    "beige800": "#282420",
    "beige900": "#1c1818",
    "gray50": "#f4f4f9",
    "gray100": "#e8e8ed",
    "gray200": "#dcdce1",
    "gray300": "#c8c8cd",
    "gray400": "#b0b0b5",
    "gray500": "#8c8c90",
    "gray600": "#606064",
    "gray700": "#48484b",
    "gray800": "#303032",
    "gray900": "#121214",
    "green100": "#ccefdd",
    "green200": "#a6e3c4",
    "green300": "#73d3a2",
    "green400": "#4cc789",
    "green500": "#26bb6f",
    "green600": "#00af56",
    "green700": "#008641",
    "green800": "#00572a",
    "green900": "#00361a",
    "red100": "#fad1de",
    "red200": "#f6aec6",
    "red300": "#f07fa5",
    "red400": "#eb5185",
    "red500": "#e4175c",
    "red600": "#be0040",
    "red700": "#890e37",
    "red800": "#5b0925",
    "red900": "#390617",
    "orange100": "#ffebcc",
    "orange200": "#ffdca6",
    "orange300": "#ffc366",
    "orange400": "#ffaf33",
    "orange500": "#ff9b00",
    "orange600": "#cc7c00",
    "orange700": "#995d00",
    "orange800": "#663e00",
    "orange900": "#402700",
    "blue100": "#ccebff",
    "blue200": "#a6dbff",
    "blue300": "#66c2ff",
    "blue400": "#33adff",
    "blue500": "#0099ff",
    "blue600": "#007acc",
    "blue700": "#00558f",
    "blue800": "#003d66",
    "blue900": "#00253d",
    "white": "#ffffff",
    "black": "#222222",
    "functionalBlack": "#000000",
    "transparent": "#000000"
};
exports.default = colors;
